import CodiSystem from '../../../codiSystem/index';
import { updateEnd } from '../../../update/updateEnd';
import { moveSelected } from '../moveSelected/index';

function freezerInsertAfter(beAddedCube: CubeNode, task: InsertInfo): void {
    // 坐标系统增加插入对象
    CodiSystem.add(beAddedCube.id);
    updateEnd();

    // 移动选择器选中态
    moveSelected(beAddedCube, task);
}

export {
    freezerInsertAfter
};
